const cxf = {
    timeChange ( date) {
        let _date = new Date(date)
        let Str = _date.getFullYear() + '-' +
        (_date.getMonth() + 1) + '-' +
        _date.getDate() + ' ' +
        _date.getHours() + ':' +
        _date.getMinutes() + ':' +
        _date.getSeconds()
        return Str;
    },
    handleUserStatus ( type , t = false ) {
        if (!t) {
            return [
                { label:'启用', value:0},
                { label:'禁用', value:1},
                { label:'请选择', value:""},
            ]
        } else {
            switch ( type ) {
                case 1 :
                    return "禁用";
                case 0 :
                    return "启用";
                default:
                    return "";
            }
        }
    },
    handleUserRole ( type ) {
        switch ( type ) {
            case 1 :
                return "录入员";
            case 99 :
                return "管理员";
            default:
                return "无角色";
        }
    },
    getMainType ( id , t = false ) {
        if ( !t ) {
            return [
                { label:'聚醚多元醇', value:"1"},
                { label:'聚合物多元醇', value:"2"},
                { label:'异氰酸酯', value:"3"},
                { label:'聚氨酯助剂', value:"4"},
                { label:'四氯乙烯及其他', value:"5"},
                { label:'特殊产品', value:"99"},
            ]
        } else {
            switch ( id ) {
                case "1" :
                    return "聚醚多元醇";
                case "2" :
                    return "聚合物多元醇";
                case "3" :
                    return "异氰酸酯";
                case "4" :
                    return "聚氨酯助剂";
                case "5" :
                    return "四氯乙烯及其他";
                case "99" :
                    return "特殊产品";
                default:
                    return "特殊产品";
            }
        }
    },
    getMainType_en ( id , t = false ) {
        if ( !t ) {
            return [
                { label:'Polyol', value:"1"},
                { label:'High Resilience Polyol', value:"2"},
                { label:'Isocyanate', value:"3"},
                { label:'PU Additives', value:"4"},
                { label:'PERC', value:"5"},
                { label:'Other Service', value:"99"},
            ]
        } else {
            switch ( id ) {
                case "1" :
                    return "Polyol";
                case "2" :
                    return "High Resilience Polyol";
                case "3" :
                    return "Isocyanate";
                case "4" :
                    return "PU Additives";
                case "5" :
                    return "PERC";
                case "99" :
                    return "Other Service";
                default:
                    return "Other Service";
            }
        }
    },
    getSubType ( mid , t = false, sid = "99" ) {
        if ( !t ) {
            switch ( mid ){
                case "0":
                    return [
                        { label:'请选择', value:"0"},
                    ]
                case "1":
                    return [
                        { label:'软泡用聚醚多元醇', value:"1"},
                        { label:'高回弹用聚醚多元醇', value:"2"},
                        { label:'慢回弹用聚醚多元醇', value:"3"},
                        { label:'CASE 用聚醚多元醇', value:"4"}
                    ]
                case "2":
                    return [
                        { label:'表活型聚醚', value:"1"},
                        { label:'聚合物多元醇', value:"2"}
                    ]
                case "3":
                    return [
                        { label:'TDI', value:"1"},
                        { label:'MDI', value:"2"}
                    ]
                case "4":
                    return [
                        { label:'硅油', value:"1"},
                        { label:'胺催化剂', value:"2"},
                        { label:'分散剂', value:"3"},
                        { label:'阻燃剂', value:"4"}
                    ]
                case "5":
                    return [
                        { label:'四氯乙烯', value:"1"},
                        { label:'丙二醇', value:"2"}
                    ]
                default:
                    return [
                        { label:'特殊产品', value:sid},
                    ]
            }
        } else {
            let tempName = "";
            switch ( mid ){
                case "0":
                    if ( sid === "0") {
                        tempName = "请选择";
                    }
                    return tempName;
                case "1":
                    if ( sid === "1") {
                        tempName = "软泡用聚醚多元醇";
                    } else if ( sid === "2") {
                        tempName = "高回弹用聚醚多元醇";
                    } else if ( sid === "3") {
                        tempName = "慢回弹用聚醚多元醇";
                    } else if ( sid === "4") {
                        tempName = "CASE 用聚醚多元醇";
                    }
                    return tempName;
                case "2":
                    if ( sid === "1") {
                        tempName = "表活型聚醚";
                    } else if ( sid === "2") {
                        tempName = "聚合物多元醇";
                    }
                    return tempName;
                case "3":
                    if ( sid === "1") {
                        tempName = "TDI";
                    } else if ( sid === "2") {
                        tempName = "MDI";
                    }
                    return tempName;
                case "4":
                    if ( sid === "1") {
                        tempName = "硅油";
                    } else if ( sid === "2") {
                        tempName = "胺催化剂";
                    } else if ( sid === "3") {
                        tempName = "分散剂";
                    } else if ( sid === "4") {
                        tempName = "阻燃剂";
                    }
                    return tempName;
                case "5":
                    if ( sid === "1") {
                        tempName = "四氯乙烯";
                    } else if ( sid === "2") {
                        tempName = "丙二醇";
                    }
                    return tempName
                default:
                    return '特殊产品'
            }
        }
    },
    getSubType_en ( mid , t = false, sid = "99" ) {
        if ( !t ) {
            switch ( mid ){
                case "0":
                    return [
                        { label:'Select', value:"0"},
                    ]
                case "1":
                    return [
                        { label:'Polyol for Flexible Polyurethane', value:"1"},
                        { label:'Polyol for High Resilience Foam', value:"2"},
                        { label:'Polyol for Slow Resilience Foam', value:"3"},
                        { label:'Polyol for CASE', value:"4"}
                    ]
                case "2":
                    return [
                        { label:'Polyol for Surfactants', value:"1"},
                        { label:'Polymer Polyol', value:"2"}
                    ]
                case "3":
                    return [
                        { label:'TDI', value:"1"},
                        { label:'MDI', value:"2"}
                    ]
                case "4":
                    return [
                        { label:'Silicone Oil', value:"1"},
                        { label:'Amine Catalyst', value:"2"},
                        { label:'Dispersant', value:"3"},
                        { label:'Fire Retardant', value:"4"}
                    ]
                case "5":
                    return [
                        { label:'PERC', value:"1"},
                        { label:'Propylene Glycol', value:"2"}
                    ]
                default:
                    return [
                        { label:'Other Service', value:sid},
                    ]
            }
        } else {
            let tempName = "";
            switch ( mid ){
                case "0":
                    if ( sid === "0") {
                        tempName = "Select";
                    }
                    return tempName;
                case "1":
                    if ( sid === "1") {
                        tempName = "Polyol for Flexible Polyurethane";
                    } else if ( sid === "2") {
                        tempName = "Polyol for High Resilience Foam";
                    } else if ( sid === "3") {
                        tempName = "Polyol for Slow Resilience Foam";
                    } else if ( sid === "4") {
                        tempName = "Polyol for CASE";
                    }
                    return tempName;
                case "2":
                    if ( sid === "1") {
                        tempName = "Polyol for Surfactants";
                    } else if ( sid === "2") {
                        tempName = "Polymer Polyol";
                    }
                    return tempName;
                case "3":
                    if ( sid === "1") {
                        tempName = "TDI";
                    } else if ( sid === 2) {
                        tempName = "MDI";
                    }
                    return tempName;
                case "4":
                    if ( sid === "1") {
                        tempName = "Silicone Oil";
                    } else if ( sid === "2") {
                        tempName = "Amine Catalyst";
                    } else if ( sid === "3") {
                        tempName = "Dispersant";
                    } else if ( sid === "4") {
                        tempName = "Fire Retardant";
                    }
                    return tempName;
                case "5":
                    if ( sid === "1") {
                        tempName = "PERC";
                    } else if ( sid === "2") {
                        tempName = "Propylene Glycol";
                    }
                    return tempName
                default:
                    return 'Other Service'
            }
        }
    },
    getProductStatus ( type , t = false ) {
        if (!t) {
            return [
                { label:'请选择', value:""},
                { label:'启用', value:"0"},
                { label:'禁用', value:"1"},
            ]
        } else {
            switch ( type ) {
                case "1" :
                    return "禁用";
                case "0" :
                    return "启用";
                default:
                    return "";
            }
        }
    },
    getProductStatus_en ( type , t = false ) {
        if (!t) {
            return [
                { label:'Please Select', value:""},
                { label:'Enable', value:"0"},
                { label:'Disable', value:"1"},
            ]
        } else {
            switch ( type ) {
                case "1" :
                    return "Disable";
                case "0" :
                    return "Enable";
                default:
                    return "";
            }
        }
    },
    getProductLang ( type , t = false ) {
        if ( !t ) {
            return [
                { label:'中文', value:'zh'},
                { label:'英文', value:'en'}
            ]
        } else {
            switch ( type ) {
                case 'zh' :
                    return "中文";
                case 'en' :
                    return "英文";
                default:
                    return "--";
            }
        }
    },
    getNewStatus ( type , t = false ) {
        if ( !t ) {
            return [
                { label:'草稿', value: 0 },
                { label:'发布', value: 1 },
                { label:'撤回', value: 2 },
                { label:'删除', value: 3 },
            ]
        } else {
            switch ( type ) {
                case 0 :
                    return "草稿";
                case 1 :
                    return "发布";
                case 2 :
                    return "撤回";
                case 3 :
                    return "删除";
                default:
                    return "--";
            }
        }
    },
    getNewStatusValue ( type ) {
        switch ( type ) {
            case "草稿" :
                return 0;
            case "发布" :
                return 1;
            case "撤回" :
                return 2;
            case "删除":
                return 3;
            default:
                return "--";
        }
    },
    getMainTypeValue ( name ) {
        switch ( name ) {
            case "聚醚多元醇" :
                return "1";
            case "聚合物多元醇" :
                return "2";
            case "异氰酸酯" :
                return "3";
            case "聚氨酯助剂" :
                return "4";
            case "四氯乙烯及其他" :
                return "5";
            case "特殊产品" :
                return "99";
        }
    },
    getMainTypeValue_en ( name ) {
        switch ( name ) {
            case "Polyol" :
                return "1";
            case "High Resilience Polyol" :
                return "2";
            case "Isocyanate" :
                return "3";
            case "PU Additives" :
                return "4";
            case "PERC" :
                return "5";
            case "Other Service" :
                return "99";
        }
    },
    getSubTypeValue ( mid , sid ) {
        let tempName = "";
        switch ( mid ){
            case '1':
                if ( sid ===  "软泡用聚醚多元醇") {
                    tempName = "1";
                } else if ( sid === "高回弹用聚醚多元醇") {
                    tempName = "2";
                } else if ( sid === "慢回弹用聚醚多元醇") {
                    tempName = "3";
                } else if ( sid === "CASE 用聚醚多元醇") {
                    tempName = "4";
                }
                return tempName;
            case "2":
                if ( sid === "表活型聚醚") {
                    tempName = "1";
                } else if ( sid === "聚合物多元醇") {
                    tempName = "2";
                }
                return tempName;
            case "3":
                if ( sid === "TDI") {
                    tempName = "1";
                } else if ( sid === "MDI") {
                    tempName = "2";
                }
                return tempName;
            case "4":
                if ( sid === "硅油") {
                    tempName = "1";
                } else if ( sid === "胺催化剂") {
                    tempName = "2";
                } else if ( sid === "分散剂") {
                    tempName = "3";
                } else if ( sid === "阻燃剂") {
                    tempName = "4";
                }
                return tempName;
            case "5":
                if ( sid === "四氯乙烯") {
                    tempName = "1";
                } else if ( sid === "丙二醇") {
                    tempName = "2";
                }
                return tempName
            default:
                return '特殊产品'
        }
    },
    getSubTypeValue_en ( mid , sid ) {
        let tempName = "";
        switch ( mid ){
            case "1":
                if ( sid ===  "Polyol for Flexible Polyurethane") {
                    tempName = "1";
                } else if ( sid === "Polyol for High Resilience Foam") {
                    tempName = "2";
                } else if ( sid === "Polyol for Slow Resilience Foam") {
                    tempName = "3";
                } else if ( sid === "Polyol for CASE") {
                    tempName = "4";
                }
                return tempName;
            case "2":
                if ( sid === "Polyol for Surfactants") {
                    tempName = '1';
                } else if ( sid === "Polymer Polyol") {
                    tempName = "2";
                }
                return tempName;
            case "3":
                if ( sid === "TDI") {
                    tempName = "1";
                } else if ( sid === "MDI") {
                    tempName = "2";
                }
                return tempName;
            case "4":
                if ( sid === "Silicone Oil") {
                    tempName = "1";
                } else if ( sid === "Amine Catalyst") {
                    tempName = "2";
                } else if ( sid === "Dispersant") {
                    tempName = "3";
                } else if ( sid === "Fire Retardant") {
                    tempName = "4";
                }
                return tempName;
            case "5":
                if ( sid === "PERC") {
                    tempName = "1";
                } else if ( sid === "Propylene Glycol") {
                    tempName = "2";
                }
                return tempName
            default:
                return 'Other Service'
        }
    },
    getProductStatusValue ( type ) {
        switch ( type ) {
            case "禁用" :
                return "1";
            case "启用" :
                return "0";
            default:
                return "";
        }
    },
    getAllType () {
        return [
            { 
                label:'聚醚多元醇', 
                value:"1",
                children:[
                    { label:'软泡用聚醚多元醇', value:"1"},
                    { label:'高回弹用聚醚多元醇', value:"2"},
                    { label:'慢回弹用聚醚多元醇', value:"3"},
                    { label:'CASE 用聚醚多元醇', value:"4"}
                ]
            },
            { 
                label:'聚合物多元醇',
                value:"2",
                children:[
                    { label:'表活型聚醚', value:"1"},
                    { label:'聚合物多元醇', value:"2"}
                ]
            },
            { 
                label:'异氰酸酯', 
                value:"3",
                children:[
                    { label:'TDI', value:"1"},
                    { label:'MDI', value:"2"}
                ]
            },
            {
                label:'聚氨酯助剂',
                value:"4",
                children:[
                    { label:'硅油', value:"1"},
                    { label:'胺催化剂', value:"2"},
                    { label:'分散剂', value:"3"},
                    { label:'阻燃剂', value:"4"}
                ]
            },
            {
                label:'四氯乙烯及其他',
                value:"5",
                children:[
                    { label:'四氯乙烯', value:"1"},
                    { label:'丙二醇', value:"2"}
                ]
            },
            {
                label:'特殊产品',
                value:"99",
                children:[
                    { label:'其他', value:"1"}
                ]
            },
        ]
    },
    getAllType_en () {
        return [
            { 
                label:'Polyol', 
                value:"1",
                children:[
                    { label:'Polyol for Flexible Polyurethane', value:"1"},
                    { label:'Polyol for High Resilience Foam', value:"2"},
                    { label:'Polyol for Slow Resilience Foam', value:"3"},
                    { label:'Polyol for CASE', value:"4"}
                ]
            },
            { 
                label:'High Resilience Polyol',
                value:"2",
                children:[
                    { label:'Polyol for Surfactants', value:"1"},
                    { label:'Polymer Polyol', value:"2"}
                ]
            },
            { 
                label:'Isocyanate', 
                value:"3",
                children:[
                    { label:'TDI', value:"1"},
                    { label:'MDI', value:"2"}
                ]
            },
            {
                label:'PU Additives',
                value:"4",
                children:[
                    { label:'Silicone Oil', value:"1"},
                    { label:'Amine Catalyst', value:"2"},
                    { label:'Dispersant', value:"3"},
                    { label:'Fire Retardant', value:"4"}
                ]
            },
            {
                label:'PERC',
                value:"5",
                children:[
                    { label:'PERC', value:"1"},
                    { label:'Propylene Glycol', value:"2"}
                ]
            },
            {
                label:'Other Service',
                value:"99",
                children:[
                    { label:'Other Service', value:"1"}
                ]
            },
        ]
    }
}

export default cxf